import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Container, Grid, Button } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import data from "../data.json";

let img = data.coverStory.image;

const useStyles = makeStyles({
  root: {
    height: "100vh",
    width: "100vw",
    verticalAlign: "middle",
    display: "table-cell",
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0, 0.8) 0%, rgba(255,255,255,0.2) 300%,  rgba(0,0,0,0.5) 130%), url(" +
      img +
      ")",
    objectFit: "cover",
    background: "rgb(255, 255, 255)",
    paddingLeft: "10%",
    backgroundSize: "cover",
  },
  textContainer: {
    margin: "40px",
    width: "100%",
    maxWidth: "700px",
  },
  image: {
    width: "30vw",
    height: "30vw",
    minWidth: "256px",
    minHeight: "256px",
    borderRadius: "5px",
    objectFit: "cover",
  },
  paragraph: {
    paddingBottom: "20px",
    fontFamily: "Lora",
    color: "white",
  },
  button: {
    backgroundColor: "rgb(53, 46, 115)",
    color: "white",
    fontSize: "18px",
  },
  h1: {
    fontFamily: "Open Sans light",
    fontSize: "calc(20px + 1.5vmin)",
    color: "white",
    marginBottom: "30px",
  },
  h2: {
    fontFamily: "Open Sans",
    fontSize: "calc(10px + 1.5vmin)",
    color: "#aaaaaa",
    marginBottom: "30px",
    textTransform: "uppercase",
    letterSpacing: "2px",
  },
});

const Cover = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="false" className={classes.root}>
      <Grid
        container
        spacing={25}
        alignItems="center"
        direction="row"
        justify="left"
      >
        <Grid item className={classes.textContainer}>
          <a
            className="titlelink"
            href={data.coverStory.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography variant="h2" gutterBottom className={classes.h1}>
              {data.coverStory.title}
            </Typography>
          </a>
          <Typography variant="h3" gutterBottom className={classes.h2}>
            {data.coverStory.author}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            className={classes.paragraph}
          >
            {data.coverStory.description}
          </Typography>
          <Button
            variant="contained"
            style={{
              color: "white",
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%), #374567",
            }}
            size="large"
            disableElevation
            onClick={(e) => {
              e.preventDefault();
              window.open(
                data.coverStory.link,
                "_blank",
                "noopener noreferrer"
              );
            }}
          >
            Read <ChevronRightIcon />{" "}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Cover;
